import { makeStyles, Tooltip } from '@material-ui/core'
import { VerticalShades, VerticalShadesClosed } from '@mui/icons-material'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useRefresh,
  useTranslate,
} from 'react-admin'
import { DoorReleaseDialog } from '../DoorDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { ResourceName } from '../../../../core/ResourceName'
import { Authority } from '../../../../core/auth/Authority'
import { DoorWorkingModes } from '../../../../core/enum/DoorWorkingModes'
import { DoorWorkingModeById } from '../../../../core/devices/doors/doors.utils'

const useStyles = makeStyles(() => ({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
}))

export const DoorReleaseCompactButton = ({ ...props }) => {
  const { jsonStatus, record } = props
  const translate = useTranslate()
  const classes = useStyles()
  const [mutate, { loading }] = useMutation()
  const hasAuthority = useHasAuthority()
  const refresh = useRefresh()
  const [stateDialogOpen, setStateDialogOpen] = useState(false)

  const handleCloseDialog = () => {
    setStateDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setStateDialogOpen(true)
  }

  const handleSetReleased = (released: boolean) => {
    mutate({
      type: sanitizeFetchType('setDoorReleased'),
      resource: ResourceName.DOORS,
      payload: {
        doorId: record?.id,
        released,
      },
    })
    handleCloseDialog()
    refresh()
  }

  return (
    <div>
      <DoorReleaseDialog
        open={stateDialogOpen}
        close={handleCloseDialog}
        handleSetReleased={handleSetReleased}
      />
      <Tooltip
        title={translate('resources.doors.actions.setState')}
        onClick={
          !loading && hasAuthority(Authority.DOORS_SET_RELEASE)
            ? handleOpenDialog
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading && hasAuthority(Authority.DOORS_SET_RELEASE)
                ? 'pointer'
                : 'default',
          }}
        >
          {(DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.DoorReleased && (
            <VerticalShades className={classes.icon} />
          )) || <VerticalShadesClosed className={classes.icon} />}
        </div>
      </Tooltip>
    </div>
  )
}
